import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

interface UserProfile {
  id: string;
  is_admin: boolean;
  email: string;
  first_name?: string;
  last_name?: string;
}

export function useUser() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const { data: { user }, error: authError } = await supabase.auth.getUser();
        
        if (authError) throw authError;
        if (!user) {
          setIsAdmin(false);
          return;
        }

        // Get user profile which includes admin status
        const { data: profile, error: profileError } = await supabase
          .from('users')
          .select('is_admin')
          .eq('user_id', user.id)
          .single();

        if (profileError) throw profileError;
        
        setIsAdmin(profile?.is_admin || false);
      } catch (err) {
        console.error('Error checking admin status:', err);
        setError(err instanceof Error ? err : new Error('Failed to check admin status'));
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();

    // Subscribe to auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkAdminStatus();
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return {
    isAdmin,
    isLoading,
    error
  };
} 